/* eslint-disable import/prefer-default-export */
import { asyncActionType } from 'util/methods';

export const PayerTypes = {
  // LIST
  GET_PAYER_LIST: asyncActionType('GET_PAYER_LIST'),

  // PAYER COMPANY
  CREATE_PAYER_COMPANY: asyncActionType('CREATE_PAYER_COMPANY'),
  UPDATE_PAYER_COMPANY: asyncActionType('UPDATE_PAYER_COMPANY'),
  DELETE_PAYER_COMPANY: asyncActionType('DELETE_PAYER_COMPANY'),

  // PAYER CONTACT PERSON
  CREATE_PAYER_CONTACT_PERSON: asyncActionType('CREATE_PAYER_CONTACT_PERSON'),
  UPDATE_PAYER_CONTACT_PERSON: asyncActionType('UPDATE_PAYER_CONTACT_PERSON'),
  DELETE_PAYER_CONTACT_PERSON: asyncActionType('DELETE_PAYER_CONTACT_PERSON'),

  // DEFAULT PAYER
  SET_DEFAULT_PAYER: asyncActionType('SET_DEFAULT_PAYER'),

  // PAYER_COMPANIES
  GET_PAYER_COMPANIES: asyncActionType('GET_PAYER_COMPANIES'),
};
